import { jsx as _jsx } from "react/jsx-runtime";
import './ButtonDivider.css';
const ButtonDivider = ({ children, className }) => {
    return _jsx("div", { className: `buttonDivider ${className !== null && className !== void 0 ? className : ''}`, children: children });
};
export default ButtonDivider;
